import { useTheme } from "@mui/material/styles"

const RtlIconWrapper = ({ children, flip = true }) => {
  const theme = useTheme()

  return (
    <span
      style={{
        display: "inline-flex",
        transform: flip && theme.direction === "rtl" ? "scaleX(-1)" : "none",
      }}
    >
      {children}
    </span>
  )
}

export default RtlIconWrapper
